(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-add-to-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.getElementById('sticky-add-to-cart');
  const siteFooter = document.querySelector('footer');
  const cartDrawerEl = document.getElementById('mini-cart');
  
  // --- PASSO 1: ACHAR O FORMULÁRIO PRINCIPAL E O BOTÃO STICKY ---
  
  // ESTA É A CORREÇÃO:
  // Procura por qualquer tag 'form' cujo ID *comece com* 'product-form-main-'
  const mainForm = document.querySelector('form[id*="product-form-main-"]');
  
  const stickyButton = stickyBar ? stickyBar.querySelector('.sticky-add-to-cart__button') : null;
  
  if (!stickyBar || !mainForm || !stickyButton) {
    if (!mainForm) {
      console.warn('Sticky Add to Cart: Não foi possível encontrar o formulário principal com o seletor: form[id*="product-form-main-"]');
    }
    return;
  }

  // --- PASSO 2: CONECTAR O BOTÃO AO FORMULÁRIO ---
  // Agora temos o ID correto, seja ele qual for.
  const mainFormId = mainForm.id;
  stickyButton.setAttribute('form', mainFormId);
  

  // --- PASSO 3: LÓGICA DE VISIBILIDADE ---
  let isFormVisible = true;
  let isFooterVisible = false;
  let isCartOpen = false;

  function updateStickyState() {
    isCartOpen = (cartDrawerEl && cartDrawerEl.hasAttribute('open'));
    isFooterVisible = (siteFooter.getBoundingClientRect().top < window.innerHeight);

    if (isCartOpen) {
      stickyBar.classList.remove('active');
    } else if (isFooterVisible) {
      stickyBar.classList.remove('active');
      stickyBar.classList.add('hide'); 
    } else {
      stickyBar.classList.remove('hide');
      // A barra só fica 'active' se o formulário principal *não* estiver visível
      // (O IntersectionObserver abaixo cuida disso)
    }
  }

  // --- Observador 1: Formulário do Produto (para visibilidade) ---
  const formObserver = new IntersectionObserver(
    ([e]) => {
      // intersectionRatio < 1 significa que o formulário *não* está 100% visível (começou a sair da tela)
      const formIsNotFullyVisible = (e.intersectionRatio < 1);
      
      // Lógica de visibilidade da barra
      isCartOpen = (cartDrawerEl && cartDrawerEl.hasAttribute('open'));
      isFooterVisible = (siteFooter.getBoundingClientRect().top < window.innerHeight);

      if (!isCartOpen && !isFooterVisible) {
         stickyBar.classList.toggle('active', formIsNotFullyVisible);
      } else if (isCartOpen || isFooterVisible) {
         stickyBar.classList.remove('active'); // Garante que está escondido se o carrinho/footer aparecerem
      }
    },
    { threshold: [1.0], rootMargin: '0px 0px -1px 0px' }
  );
  formObserver.observe(mainForm);
  
  // --- Observador 2: Rodapé ---
  if (siteFooter) {
    const footerObserver = new IntersectionObserver(
      ([e]) => {
        isFooterVisible = (e.intersectionRatio > 0);
        updateStickyState();
      },
      { threshold: [0], rootMargin: '0px 0px -70px 0px' }
    );
    footerObserver.observe(siteFooter);
  }

  // --- Observador 3: Gaveta do Carrinho (Cart Drawer) ---
  if (cartDrawerEl) {
    const cartObserver = new MutationObserver(() => {
      updateStickyState();
    });
    cartObserver.observe(cartDrawerEl, { 
      attributes: true, 
      attributeFilter: ['open']
    });
  }

  // Timeout inicial de visibilidade
  setTimeout(() => {
    stickyBar.style.visibility = 'visible';
  }, 300);
  
  // Executa uma verificação inicial
  updateStickyState();
});

  } catch(e) { console.error(e); }
})();
})();
